'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function HomepageCategories({ categories }: { categories: CategoriesEntity[] }) {
  return (
    <section
      className={cn(
        'custom-section',
        'gap-24 py-12 sm:gap-28 sm:py-16 lg:gap-[120px] lg:py-[120px]',
      )}
    >
      {categories.map((category, index) => (
        <CategoryPreview category={category} key={category.slug} reverse={index % 2 !== 1} />
      ))}
    </section>
  );
}

function CategoryPreview({ category, reverse }: { category: CategoriesEntity; reverse?: boolean }) {
  return (
    <div
      className={cn(
        'flex w-full max-w-[1440px] flex-col-reverse items-start gap-8 md:items-center md:gap-6 lg:gap-12 xl:gap-0',
        reverse ? 'md:flex-row-reverse md:justify-end' : 'md:flex-row md:justify-end',
      )}
    >
      <div
        className={cn(
          'flex flex-col items-start justify-start gap-4 sm:max-w-[588px] sm:gap-5 lg:gap-6',
          reverse ? 'xl:ml-[120px]' : 'xl:mr-[120px]',
        )}
      >
        <h2 className="font-oswald text-3xl font-medium uppercase text-black sm:text-4xl lg:text-5xl">
          {category.name}
        </h2>
        <Paragraph
          className="w-full font-medium"
          color="black"
          innerHtml={category?.short_description || ''}
          size="base"
        />
        <Button asChild className="w-full font-oswald font-normal uppercase sm:w-fit">
          <Link prefetch={false} href={ROUTES.CATEGORY({ slug: category.slug || '' })}>
            PREZERAŤ PRODUKTY
          </Link>
        </Button>
      </div>
      <div className="relative w-full overflow-hidden sm:max-w-[612px]">
        <h3
          className={cn(
            'absolute -bottom-2 z-10 whitespace-nowrap font-oswald text-7xl font-medium uppercase text-white sm:-bottom-3 sm:text-7xl md:text-[90px] lg:text-[105px] xl:text-[130px]',
            reverse ? '-right-2' : '-left-2',
          )}
        >
          {category.name}
        </h3>
        <Image
          src={category?.image?.url ?? ''}
          alt={resolveImageAlt(category?.image, category?.name)}
          width={0}
          height={0}
          className="h-[400px] w-full object-cover object-center sm:h-[450px] sm:max-w-[612px]"
          sizes="100vw"
        />
      </div>
    </div>
  );
}
